// @flow
import Config from '../lib/Config';
import merchants from './merchants';
import config from './config';
import navigation from './navigation';

import type { TActionType } from './actionTypes';
import type { TNavigationState } from './navigation';
import type { TMerchantsState, TMerchantsQuery } from './merchants';
import Merchant from '../lib/Merchant';

export type TAction = {
  type: TActionType,
  payload: {
    navigation?: TNavigationState,
    merchants?: TMerchantsState,
    config?: Config,
  },
};

export type TRootState = {
  navigation: TNavigationState,
  merchants: TMerchantsState,
  config: Config,
};

export type TNavigateToActionCreator = (path: string, state?: any) => void;
export type TVoidActionCreator = () => void | any;
export type TAsyncFetchConfigActionCreator = () => Promise<Config>;
export type TAsyncFetchMerchantsActionCreator = (query: TMerchantsQuery) => Promise<Array<Merchant>>;
export type TAsyncLinkAccountActionCreatorOptions = {
  mch_id: string,
  account_number: string,
  public_plaid_account_token?: ?string,
};
export type TAsyncLinkAccountActionCreator = (data: TAsyncLinkAccountActionCreatorOptions) => Promise<string>;

// asyncLinkPlaidAccount
export type TAsyncLinkPlaidAccountActionCreatorOptions = {
  public_plaid_account_token: string,
  accounts: Array<{
    account_id: string,
    account_number: ?string,
  }>,
};

export type TAsyncLinkPlaidAccountActionCreatorResults = {
  public_account_token: string,
  aggregated_accounts: Array<{
    public_account_token: string,
    mask: string,
  }>,
};

export type TAsyncLinkPlaidAccountActionCreator = (data: TAsyncLinkPlaidAccountActionCreatorOptions) =>
  Promise<TAsyncLinkPlaidAccountActionCreatorResults>;

export type TAsyncLinkMXAccountActionCreator = (data: { member_guid: string }) => Promise<any>;

export type TActionCreators = {
  navigateTo: TNavigateToActionCreator,
  navigateBack: TVoidActionCreator,
  asyncFetchConfig: TAsyncFetchConfigActionCreator,
  asyncFetchMerchants: TAsyncFetchMerchantsActionCreator,
  asyncLinkAccount: TAsyncLinkAccountActionCreator,
  asyncLinkPlaidAccount: TAsyncLinkPlaidAccountActionCreator,
  asyncLinkMXAccount: TAsyncLinkMXAccountActionCreator,
  async_delete_link_token: TVoidActionCreator,
};

// $FlowFixMe
export default combineReducers({ merchants, config, navigation });

function combineReducers(reducers: Object) {
  const reducerKeys = Object.keys(reducers);

  return (state = {}, action) => {
    return reducerKeys.reduce((acc, key) => {
      const reducer = reducers[key];
      const previousStateForKey = state[key];
      return Object.assign({}, acc, { [key]: reducer(previousStateForKey, action) });
    }, {});
  }
}
